/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ScheduleConstraintEntity
 */
export interface ScheduleConstraintEntity {
    /**
     * 
     * @type {string}
     * @memberof ScheduleConstraintEntity
     */
    id?: string;
    /**
     * 
     * @type {any}
     * @memberof ScheduleConstraintEntity
     */
    schedule?: any | null;
    /**
     * 
     * @type {string}
     * @memberof ScheduleConstraintEntity
     */
    tenantId?: string;
    /**
     * 
     * @type {string}
     * @memberof ScheduleConstraintEntity
     */
    constraintType?: ScheduleConstraintEntityConstraintTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ScheduleConstraintEntity
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof ScheduleConstraintEntity
     */
    description?: string;
    /**
     * 
     * @type {Date}
     * @memberof ScheduleConstraintEntity
     */
    startTime?: Date;
    /**
     * 
     * @type {Date}
     * @memberof ScheduleConstraintEntity
     */
    endTime?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof ScheduleConstraintEntity
     */
    active?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ScheduleConstraintEntity
     */
    priority?: number;
    /**
     * 
     * @type {string}
     * @memberof ScheduleConstraintEntity
     */
    constraintConfig?: string;
    /**
     * 
     * @type {string}
     * @memberof ScheduleConstraintEntity
     */
    affectedParticipants?: string;
    /**
     * 
     * @type {string}
     * @memberof ScheduleConstraintEntity
     */
    metadata?: string;
    /**
     * 
     * @type {Date}
     * @memberof ScheduleConstraintEntity
     */
    createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof ScheduleConstraintEntity
     */
    updatedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof ScheduleConstraintEntity
     */
    createdBy?: string;
    /**
     * 
     * @type {string}
     * @memberof ScheduleConstraintEntity
     */
    updatedBy?: string;
}


/**
 * @export
 */
export const ScheduleConstraintEntityConstraintTypeEnum = {
    Holiday: 'HOLIDAY',
    BusinessHours: 'BUSINESS_HOURS',
    Maintenance: 'MAINTENANCE',
    TimeOff: 'TIME_OFF',
    Blackout: 'BLACKOUT',
    SkillRequirement: 'SKILL_REQUIREMENT',
    Location: 'LOCATION',
    Custom: 'CUSTOM'
} as const;
export type ScheduleConstraintEntityConstraintTypeEnum = typeof ScheduleConstraintEntityConstraintTypeEnum[keyof typeof ScheduleConstraintEntityConstraintTypeEnum];


/**
 * Check if a given object implements the ScheduleConstraintEntity interface.
 */
export function instanceOfScheduleConstraintEntity(value: object): value is ScheduleConstraintEntity {
    return true;
}

export function ScheduleConstraintEntityFromJSON(json: any): ScheduleConstraintEntity {
    return ScheduleConstraintEntityFromJSONTyped(json, false);
}

export function ScheduleConstraintEntityFromJSONTyped(json: any, ignoreDiscriminator: boolean): ScheduleConstraintEntity {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'schedule': json['schedule'] == null ? undefined : json['schedule'],
        'tenantId': json['tenantId'] == null ? undefined : json['tenantId'],
        'constraintType': json['constraintType'] == null ? undefined : json['constraintType'],
        'name': json['name'] == null ? undefined : json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'startTime': json['startTime'] == null ? undefined : (new Date(json['startTime'])),
        'endTime': json['endTime'] == null ? undefined : (new Date(json['endTime'])),
        'active': json['active'] == null ? undefined : json['active'],
        'priority': json['priority'] == null ? undefined : json['priority'],
        'constraintConfig': json['constraintConfig'] == null ? undefined : json['constraintConfig'],
        'affectedParticipants': json['affectedParticipants'] == null ? undefined : json['affectedParticipants'],
        'metadata': json['metadata'] == null ? undefined : json['metadata'],
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
        'updatedAt': json['updatedAt'] == null ? undefined : (new Date(json['updatedAt'])),
        'createdBy': json['createdBy'] == null ? undefined : json['createdBy'],
        'updatedBy': json['updatedBy'] == null ? undefined : json['updatedBy'],
    };
}

export function ScheduleConstraintEntityToJSON(json: any): ScheduleConstraintEntity {
    return ScheduleConstraintEntityToJSONTyped(json, false);
}

export function ScheduleConstraintEntityToJSONTyped(value?: ScheduleConstraintEntity | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'schedule': value['schedule'],
        'tenantId': value['tenantId'],
        'constraintType': value['constraintType'],
        'name': value['name'],
        'description': value['description'],
        'startTime': value['startTime'] == null ? undefined : ((value['startTime']).toISOString()),
        'endTime': value['endTime'] == null ? undefined : ((value['endTime']).toISOString()),
        'active': value['active'],
        'priority': value['priority'],
        'constraintConfig': value['constraintConfig'],
        'affectedParticipants': value['affectedParticipants'],
        'metadata': value['metadata'],
        'createdAt': value['createdAt'] == null ? undefined : ((value['createdAt']).toISOString()),
        'updatedAt': value['updatedAt'] == null ? undefined : ((value['updatedAt']).toISOString()),
        'createdBy': value['createdBy'],
        'updatedBy': value['updatedBy'],
    };
}

